
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import dayjs from "dayjs";
import { Table } from "@common/src/utils/decorator";
import BtnRadio from "@/components/scope/btn-radio.vue";
import FilterBar from "./components/filter-bar.vue";
import { addCurrencyUnit, addCurrencySymbol } from "@common/src/utils/tools";
import { formDownload } from "@common/src/utils/tools";
import t from "@common/src/i18n/t";

const base = namespace("base");
const common_statement = namespace("common_statement");

@Component({
  components: { BtnRadio, FilterBar },
  filters: {}
})
@Table("loadListData")
export default class Statement extends Vue {
  @common_statement.Action queryReceiptReportList;
  @base.Action getDictionaryList;
  addCurrencyUnit = addCurrencyUnit;
  addCurrencySymbol = addCurrencySymbol;
  dayjs = dayjs;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  searchForm: any = {
    receiptType: "",
    reportType: "1", // 时间范围类型, date-按日,month-按月
    receiptTimeFrom: "", // 开始时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
    receiptTimeTo: "" // 结束时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
  };
  contentList: any = [];
  created() {
    this.init();
  }
  toStatementView(row) {
    let slectedDate = row.receiptTime.split("-").join("");
    let searchForm = Object.assign({}, this.searchForm, {
      receiptTimeFrom: slectedDate,
      receiptTimeTo: slectedDate
    });
    window.open(
      this.$router.resolve(`/statement/receipt-report-analysis?searchForm=${JSON.stringify(searchForm)}`).href
    );
  }

  selfData: any = [];
  serviceListCopy: any = [];
  partsListCopy: any = [];
  get searchList() {
    let timeRow = [
      {
        label: t("v210831.time-frame"),
        type: "select-view",
        value: "",
        prop: "reportType",
        selectList: [
          {
            value: "1",
            label: t("v210831.query-by-day"),
            itemValue: "",
            itemType: "daterange",
            itemProp: "dateValue",
            itemValueFormat: "yyyyMMdd"
          },
          {
            value: "2",
            label: t("v210831.query-by-month"),
            itemValue: "",
            itemType: "monthrange",
            itemProp: "dateValue",
            itemValueFormat: "yyyyMM"
          }
        ]
      }
    ];
    return [
      ...timeRow,
      {
        label: t("finance.proceeds-type"),
        type: "select",
        value: "",
        prop: "receiptType",
        placeholder: t("v210831.please-select"),
        selectList: this.receiptTypeList
      }
    ];
  }
  receiptTypeList: any = [];
  init() {
    this.getDictionaryList("receipt_type").then(data => {
      this.receiptTypeList = data;
    });
  }
  handleExportData() {
    formDownload(`${window.API_URL}/receipt/excel/byReceiptType`, this.searchForm);
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryReceiptReportList({
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.totalReceiptAmount = data.data.totalReceiptAmount;
      this.contentList = data.data.list;
      return data;
    });
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    let hasError = false;
    data.forEach(item => {
      if (item.prop) {
        if (item.type === "select-view") {
          item.selectList.forEach(val => {
            if (val.value === item.value) {
              if (val.itemProp === "dateValue") {
                if (item.value === "1") {
                  // 天数不超过31天
                  const [start, end] = val.itemValue;
                  if (dayjs(start).add(31, "day").startOf("day").isBefore(dayjs(end))) {
                    return this.$message.error(t("v213.the-selected-range-can-not-exceed-31-days"));
                  }
                } else {
                  // 月份不超过12个月
                  const [start, end] = val.itemValue;
                  if (dayjs(start).add(12, "month").startOf("month").isBefore(dayjs(end))) {
                    return this.$message.error(t("v213.the-selected-range-can-not-exceed-12-months"));
                  }
                }
                this.searchForm.receiptTimeFrom = val.itemValue[0] || "";
                this.searchForm.receiptTimeTo = val.itemValue[1] || "";
              } else {
                this.searchForm[val.itemProp] = val.itemValue;
              }
            }
          });
          if (item.prop === "reportType") {
            this.searchForm[item.prop] = item.value;
          }
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    if (hasError) return;
    this.selfData = data;
    this.loadListData();
  }
  totalReceiptAmount = "";
}
